import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'medpace-payment-request-deduction-view',
    imports: [DecimalPipe],
    templateUrl: './payment-request-deduction-view.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentRequestDeductionViewComponent {
    amount = input.required<number>();
    amountConverted = input<number>();
    currency = input.required<string>();
}
